<template>
  <ul
    id="main-menu-navigation"
    class="nav navbar-nav"
  >
    <component
      :is="resolveNavComponent(item)"
      v-for="item in items"
      :key="item.header || item.title"
      v-if="handleShowMenu(item.header || item.title, profileData.role)"
      :item="item"
    />
  </ul>
</template>

<script>
import { mapGetters} from 'vuex'
import HorizontalNavMenuHeaderLink from '../horizontal-nav-menu-header-link/HorizontalNavMenuHeaderLink.vue'
import HorizontalNavMenuHeaderGroup from '../horizontal-nav-menu-header-group/HorizontalNavMenuHeaderGroup.vue'
import MenuReportPermission, { restrictedReportPermission } from '@/common/permission/menu/report'
export default {
  components: {
    HorizontalNavMenuHeaderLink,
    HorizontalNavMenuHeaderGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      profileData: 'User/user',
    })
  },
  data () {
    return {
      menuReportPermission: MenuReportPermission,
      restrictedReportPermission: restrictedReportPermission,
      handleHeader: [
        'Report',
        'Ticket Detail Report (New)',
        'Ticket Summary By Agent', 
        'Ticket Summary By Channel',
        'Ticket Summary By Case Type',
        'Detail Report'
      ],
      restrictedReportHeader: [
        'Categories',
        'Complain Report'
      ]
    }
  },
  methods: {
    handleShowMenu(header, role) {
      if (!header || !role) {
        return true // แสดงเมนูถ้าไม่มีข้อมูล
      }
      
      // ตรวจสอบ Categories Report และ Complain Report ก่อน (Super Admin เท่านั้น)
      if(this.restrictedReportHeader.includes(header) && !this.restrictedReportPermission.includes(role)) {
        return false
      }
      
      // ตรวจสอบ Report ทั่วไป
      if(this.handleHeader.includes(header) && !this.menuReportPermission.includes(role)) {
        return false
      }
      
      return true
    }
  },
  setup() {
    const resolveNavComponent = item => {
      if (item.children) return 'horizontal-nav-menu-header-group'
      return 'horizontal-nav-menu-header-link'
    }

    return {
      resolveNavComponent,
    }
  },
}
</script>
<style scoped>
.text-black {
  color: #000
}
</style>